type VoucherEnrichmentFields = {
  voucher_rule_product?: unknown;
  has_voucher_discount?: boolean;
  voucher_discount_percentage?: number;
  voucher_discount_amount?: number;
  voucher_reward_type?: unknown;
  voucher_code?: string;
};

type WithId = { id: string };

export function enrichPOItemsWithVoucher<
  TMeta extends WithId,
  TDetail extends WithId
>(
  metaItems: TMeta[],
  detailItems: Array<TDetail & VoucherEnrichmentFields>
): Array<TMeta & VoucherEnrichmentFields> {
  const detailById = new Map<string, VoucherEnrichmentFields>();
  for (const item of detailItems) {
    detailById.set(item.id, {
      voucher_rule_product: item.voucher_rule_product,
      has_voucher_discount: item.has_voucher_discount,
      voucher_discount_percentage: item.voucher_discount_percentage,
      voucher_discount_amount: item.voucher_discount_amount,
      voucher_reward_type: item.voucher_reward_type,
      voucher_code: item.voucher_code,
    });
  }

  return metaItems.map((metaItem) => ({
    ...metaItem,
    ...(detailById.get(metaItem.id) ?? {}),
  }));
}
